// 权限管理路由
const integral: any = [
    {
        path: 'integral/badList',
        name: 'bad_debt_statistics',
        meta: {
            title: '坏账统计'
        },
        component: () => import('@/views/integral/badList.vue')
    },
    {
        path: 'integral/virtualGoods',
        name: 'applet_goods_card_4',
        meta: {
            title: '虚拟商品库'
        },
        component: () => import('@/views/integral/virtualGoods.vue')
    },
    {
        path: 'integral/virtualGoodsEdit',
        name: 'applet_goods_card_goods_edit',
        meta: {
            
            title: '虚拟商品库编辑',
            pathTitle: 'applet_goods_card_4'
        },
        component: () => import('@/views/integral/virtualGoodsEdit.vue')
    },
    {
        path: 'integral/commodity',
        name: 'applet_goods',
        meta: {
            title: '商品管理'
        },
        component: () => import('@/views/integral/commodity.vue')
    },
    {
        path: 'integral/commodityEdit',
        name: 'applet_goods_edit',
        meta: {
            title: '商品管理编辑',
            pathTitle: 'applet_goods'
        },
        component: () => import('@/views/integral/commodityEdit.vue')
    },
    {
        path: 'integral/pointsDetails',
        name: 'applet_integral_detail',
        meta: {
            title: '积分明细'
        },
        component: () => import('@/views/integral/pointsDetails.vue')
    },
    {
        path: 'integral/withdrawal',
        name: 'applet_integral_withdraw',
        meta: {
            title: '积分提现'
        },
        component: () => import('@/views/integral/withdrawal.vue')
    },
    {
        path: 'integral/withdrawalApproval',
        name: 'applet_integral_apply',
        meta: {
            title: '提现审批'
        },
        component: () => import('@/views/integral/withdrawalApproval.vue')
    },
    {
        path: 'integral/approalCard',
        name: 'approal',
        meta: {
            title: '提现审批',
            pathTitle: 'applet_integral_apply'
        },
        component: () => import('@/views/integral/approalCard.vue')
    }
]
export default integral
